import React from 'react'
import PropTypes from 'prop-types'

// Gmail promotions-tab chrome: hamburger + avatar header row, an
// "Ad · {businessName} ↗" sender row, headline/description, and a few fake
// inbox rows below (Figma node 31518:16487 desktop-video — see
// googleDisplayVariations.js). No media area.
//
// When `ad.logo` is present, the sender row shows a small square advertiser
// icon before the business name (`logo` isn't Demand-Gen-exclusive — Display
// creatives render it too).
const GmailChromeCard = ({ ad }) => {
  const { headline, description, businessName, logo } = ad

  return (
    <div className="google-display-card google-display-card--gmail">
      <div className="google-display-card__gmail-header">
        <span className="google-display-card__hamburger">
          <span />
          <span />
          <span />
        </span>
        <span className="google-display-card__avatar" />
      </div>
      <div className="google-display-card__gmail-ad-row">
        <span className="google-display-card__ad-tag google-display-card__ad-tag--inline">Ad</span>
        {logo?.url && (
          <img className="google-display-card__gmail-logo" src={logo.url} alt={businessName} />
        )}
        <span className="google-display-card__gmail-sender">{businessName} ↗</span>
      </div>
      <div className="google-display-card__headline google-display-card__headline--gmail">
        {headline}
      </div>
      <div className="google-display-card__description">{description}</div>
      <div className="google-display-card__gmail-inbox">
        <div className="google-display-card__gmail-row" />
        <div className="google-display-card__gmail-row" />
        <div className="google-display-card__gmail-row" />
      </div>
    </div>
  )
}

GmailChromeCard.propTypes = {
  ad: PropTypes.shape({
    headline: PropTypes.string,
    description: PropTypes.string,
    businessName: PropTypes.string,
    logo: PropTypes.object,
  }).isRequired,
}

export default GmailChromeCard
